import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductState } from '../reducers';

export const selectProductState = createFeatureSelector<ProductState>('product');

export const selectProductLoading = createSelector(
  selectProductState,
  (state: ProductState) => state.loading
);

export const selectProductList = createSelector(
  selectProductState,
  (state: ProductState) => state?.productList ?? []
);

export const selectProductError = createSelector(
  selectProductState,
  (state: ProductState) => state.error
);

export const selectProductId = createSelector(
  selectProductState,
  (state: ProductState) => state.idArticulo
);

export const selectSuggestionItems = createSelector(
  selectProductState,
  (state: ProductState) => state.suggestionItems ?? []
);
